import { FC } from "react";
import { apiURL, cn } from "../../../utils";

import { pulseAIBlack, pulseAIWhite } from "../../../assets/index";
import { useStore } from "../../../store/store";
import { useTheme } from "../ThemeToggler";

export type TBrandProps = { className?: string; onClick?: () => void };

export const Brand: FC<TBrandProps> = ({ className, onClick }) => {
  const brandingList = useStore((state) => state.brandingList);
  const { theme } = useTheme();

  // Pick logo based on theme
  const logo =
    theme === "dark"
      ? brandingList?.logo_main_dark
      : brandingList?.logo_main_light;

  const logoSrc =
    logo && typeof logo === "string" && logo.trim() !== ""
      ? logo.startsWith("http")
        ? logo
        : apiURL(logo).toString()
      : logo && typeof logo !== "string"
        ? URL.createObjectURL(logo)
        : "";

  return (
    <div
      role="button"
      data-testid="image-logo-testid"
      onClick={onClick}
      className={cn("flex gap-2 px-4 sidebar-logo-parent-div", className)}
    >
      {logoSrc ? (
        <img src={logoSrc} className="logo" alt="MainLogo" />
      ) : (
        <>
          {/* Light Theme Logo */}
          <img
            src={pulseAIBlack}
            className="logo dark:hidden"
            alt="Main Logo"
          />

          {/* Dark Theme Logo */}
          <img
            src={pulseAIWhite}
            className="logo hidden dark:block"
            alt="Main Logo"
          />
        </>
      )}
    </div>
  );
};
